var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7B3FF1",
    d: "M3.125 8h24.75C28.494 8 29 8.525 29 9.167V29H3.125C2.506 29 2 28.475 2 27.833V9.167C2 8.525 2.506 8 3.125 8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9564F4",
    d: "M8.875 8h19.25c.481 0 .875.525.875 1.167V29H8.875C8.394 29 8 28.475 8 27.833V9.167C8 8.525 8.394 8 8.875 8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEC0C4",
    d: "M29 30.262V13h5.694c.805 0 1.543.43 1.946 1.142l1.767 4.24c.392.69.593 1.459.593 2.25V28c0 1.244-1.007 2.262-2.237 2.262H29Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.147 21.128h-1.73a.577.577 0 0 0 0 1.154h1.73a.577.577 0 0 0 0-1.154Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDDFE2",
    d: "M30.552 19h5.906c.411 0 .67-.416.476-.759l-1.439-3.68a1.085 1.085 0 0 0-.962-.561H30.54a.526.526 0 0 0-.541.52v3.96c0 .291.238.52.54.52h.012Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 4,
    x: 1,
    y: 27,
    fill: "#5A5C60",
    rx: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#282A2E",
    d: "M29 34a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29 32a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#282A2E",
    d: "M9 34a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 32a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnsite);
export default __webpack_public_path__ + "static/media/Onsite.252e12e5975024b3b4f58fa36e91e65a.svg";
export { ForwardRef as ReactComponent };